// import Box from "@mui/material/Box";
// import MenuItem from "@mui/material/MenuItem";
// import FormControl from "@mui/material/FormControl";
// import Select from "@mui/material/Select";
// import { useState, useEffect } from "react";
// import localizIconGm from "../../Assets/images/localizationG.webp";
// import localizIconEN from "../../Assets/images/usFlag.webp";
// import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
// import { useTranslation } from "react-i18next";

// export default function LocalizationDropDown() {
//   const { i18n } = useTranslation();
//   // const defaultLang = i18n?.language ?? "de";
//   const defaultLang = "de";
//   const [language, setLanguage] = useState(defaultLang);

//   useEffect(() => {
//     if (i18n.language !== language)
//     {
//       i18n.changeLanguage(language);
//     }
//   }, [language, i18n]);

//   const languages = [
//     {
//       value: "de",
//       label: "Deutsch",
//       icon: localizIconGm,
//     },
//     {
//       value: "en",
//       label: "English",
//       icon: localizIconEN,
//     },
//   ];

//   const handleChange = (event) => {
//     const selectedLang = event.target.value;
//     if (selectedLang !== language)
//     {
//       i18n.changeLanguage(selectedLang);
//       setLanguage(selectedLang);
//     }
//   };

//   return (
//     <Box sx={{ minWidth: 60 }}>
//       <FormControl fullWidth>
//         <Select
//           sx={{
//             outline: "none",
//             ".MuiOutlinedInput-notchedOutline": {
//               border: "none",
//             },
//             "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//               border: "none",
//             },
//             ".MuiInputBase-input": {
//               padding: "10px",
//               display: "flex",
//               alignItems: "center",
//             },
//             ".MuiSelect-icon": {
//               right: "10px",
//               top: "50%",
//               transform: "translateY(-50%)",
//             },
//           }}
//           renderValue={(value) => {
//             const selectedLang = languages.find((x) => x.value === value);
//             return (
//               <img
//                 src={selectedLang?.icon || localizIconEN}
//                 style={{ borderRadius: "50%" }}
//                 alt={selectedLang?.value || "en"}
//                 height={"25px"}
//                 width={"25px"}
//               />
//             );
//           }}
//           IconComponent={KeyboardArrowDownRoundedIcon}
//           value={language}
//           onChange={handleChange}
//         >
//           {languages.map((lang, index) => (
//             <MenuItem key={index} value={lang.value}>
//               <img
//                 src={lang.icon}
//                 alt={lang.label}
//                 style={{ borderRadius: "50%" }}
//                 height={"30px"}
//                 width={"30px"}
//               />
//               <span style={{ color: "#000", paddingLeft: "0.5rem" }}>
//                 {lang.label}
//               </span>
//             </MenuItem>
//           ))}
//         </Select>
//       </FormControl>
//     </Box>
//   );
// }



import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useEffect, useState } from "react";
import localizIconGm from "../../Assets/images/localizationG.webp";
import localizIconEN from "../../Assets/images/usFlag.webp";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { useTranslation } from "react-i18next";

export default function LocalizationDropDown() {
  const { i18n } = useTranslation();
  const [language, setLanguage] = useState(i18n.language ?? "de");
  const languages = [
    {
      value: "de",
      label: "Deutsch",
      icon: localizIconGm,
    },
    {
      value: "en-US",
      label: "English",
      icon: localizIconEN,
    },
    
    // {
    //   value: "se",
    //   label: "Español",
    //   icon: localizIconSE,
    // },
  ];

  useEffect(() => {
    if (language !== i18n.language) {
      setLanguage(i18n.language);
    }
  }, [i18n.language]);

  
  const handleChange = (event) => {
    const selectedLang = event.target.value;
    if (selectedLang && selectedLang !== language) {
      i18n.changeLanguage(selectedLang);
      setLanguage(selectedLang);
    }
  };

  return (
    <Box sx={{ minWidth: 60 }}>
      <FormControl fullWidth>
        <Select
          sx={{
            outline: "none",
            ".MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            ".MuiInputBase-input": {
              padding: "10px",
              display: "flex",
              alignItems: "center",
            },
            ".MuiSelect-icon": {
              right: "10px", // Adjust the position of the dropdown arrow
              top: "50%",
              transform: "translateY(-50%)", // Vertically center the dropdown arrow
            },
          }}
          renderValue={(e) => {
            const language = languages.find((x) => x.value === e);

            if (language)
            {
              return (
                <img
                loading="lazy"
                  src={language.icon}
                  style={{ borderRadius: "50%" }}
                  alt={language.value}
                  height={"25px"}
                  width={"25px"}
                />
              );
            }
            return (
              <img
                src={localizIconEN}
                style={{ borderRadius: "50%" }}
                height={"25px"}
                alt={"En"}
                width={"25px"}
              />
            );
          }}
          IconComponent={KeyboardArrowDownRoundedIcon}
          value={language}
          onChange={handleChange}
        >
          {languages.map((x, i) => {
            return (
              <MenuItem key={i} value={x.value}>
                <img
                  src={x.icon}
                  alt=""
                  style={{ borderRadius: "50%" }}
                  height={"30px"}
                  width={"30px"}
                />
                <span style={{ color: "#000", paddingLeft: "0.5rem" }}>
                  {x.label}
                </span>
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Box>
  );
}
